import React from 'react';
import UpperBody from './UpperBody';

const Body = () => {
    return (
        <div className = "Body">
            <UpperBody></UpperBody>
        </div>
    )
}

export default Body
